import { render, staticRenderFns } from "./Strengths.vue?vue&type=template&id=a559788c&"
import script from "./Strengths.vue?vue&type=script&lang=js&"
export * from "./Strengths.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports